import { IconType, SvgIcon } from './SvgIcon';

export const GoogleIcon: IconType = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24" width="20" height="20">
    <path
      d="M12 5.5C13.527 5.5 15.006 6.039 16.173 7.023L19.443 3.909C18.188 2.752 16.68 1.903 15.039 1.43C13.399 0.957 11.67 0.873 9.992 1.184C8.313 1.496 6.73 2.194 5.368 3.224C4.006 4.254 2.903 5.587 2.147 7.118L5.833 9.959C6.263 8.663 7.09 7.535 8.197 6.734C9.304 5.934 10.634 5.502 12 5.5Z"
      fill="#D94F3D"
    />
    <path
      d="M5.5 12C5.501 11.306 5.613 10.617 5.833 9.959L2.147 7.118C1.392 8.635 1 10.306 1 12C1 13.694 1.392 15.365 2.147 16.882L5.833 14.04C5.613 13.383 5.501 12.693 5.5 12Z"
      fill="#F2C042"
    />
    <path
      d="M18.55 10H12.05V14.5H18C17.646 15.772 16.835 16.869 15.722 17.581L19.38 20.401C21.718 18.303 23.091 14.891 22.55 10Z"
      fill="#5085ED"
    />
    <path
      d="M15.721 17.581C14.591 18.228 13.302 18.546 12 18.5C10.634 18.498 9.304 18.066 8.197 17.266C7.09 16.465 6.263 15.337 5.833 14.04L2.147 16.882C3.057 18.718 4.462 20.263 6.202 21.343C7.943 22.424 9.951 22.998 12 23C14.696 23.073 17.324 22.147 19.379 20.4L15.721 17.581Z"
      fill="#57A75C"
    />
  </SvgIcon>
);

GoogleIcon.displayName = 'GoogleIcon';
